import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Articles from '../views/Articles.vue'
import AdminLogin from '../views/AdminLogin.vue'

import { apiCheckUser } from '../utils/api'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: { name: 'Articles' },
    meta: { requiresAuth: false },
    children: [
      {
        path: 'articles',
        name: 'Articles',
        meta: { requiresAuth: false },
        component: Articles
      },
      {
        path: 'article/:id(1|2)',
        name: 'Article',
        meta: { requiresAuth: false },
        component: () => import('../views/ArticleGallery.vue')
      },
      {
        path: 'models/:gender(men|women)',
        name: 'AllModels',
        meta: { requiresAuth: false },
        component: () => import(/* webpackChunkName: "client-models" */ '../views/AllModels.vue')
      },
      {
        path: 'models/:gender(men|women)/:name',
        name: 'ModelProfile',
        meta: { requiresAuth: false },
        component: () => import(/* webpackChunkName: "client-models" */ '../views/ModelProfile.vue')
      },
      {
        path: 'become-a-model',
        name: 'BecomeAModel',
        meta: { requiresAuth: false },
        component: () => import('../views/BecomeModel.vue')
      }
    ]
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    meta: { requiresAuth: false },
    component: AdminLogin
  },
  {
    path: '/admin/',
    name: 'AdminHome',
    meta: { requiresAuth: true },
    redirect: { name: 'AdminRequests' },
    component: () => import('../views/AdminHome.vue'),
    children: [
      {
        path: 'requests',
        name: 'AdminRequests',
        meta: { requiresAuth: true },
        component: () => import( '../views/AdminRequests.vue')
      },
      {
        path: 'request/:id',
        name: 'AdminRequestView',
        meta: { requiresAuth: true },
        component: () => import( '../views/AdminRequestView.vue')
      },
      {
        path: 'models',
        name: 'AdminModels',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "admin-models" */ '../views/AdminModels.vue')
      },
      {
        path: 'articles',
        name: 'AdminArticles',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "admin-articles" */ '../views/AdminArticles.vue')
      },
      {
        path: 'article/:id(1|2)',
        name: 'AdminArticleEdit',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "admin-articles" */ '../views/AdminArticleEdit.vue')
      },
      {
        path: 'model/new',
        name: 'AdminModelNew',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "admin-models" */ '../views/AdminModelEdit.vue')
      },
      {
        path: 'model/:id/edit',
        name: 'AdminModelEdit',
        meta: { requiresAuth: true },
        component: () => import(/* webpackChunkName: "admin-models" */ '../views/AdminModelEdit.vue')
      },
      {
        path: '*',
        meta: { requiresAuth: false },
        redirect: { name: 'AdminHome' }
      }
    ]
  },
  {
    path: '*',
    meta: { requiresAuth: false },
    redirect: { name: 'Home' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    try {
      const result = await apiCheckUser()
      if (result) {
        next()
      } else {
        next({ name: 'AdminLogin' })
      }
    } catch(e) {
      console.error(e.message)
      next({ name: 'AdminLogin' })
    }
  } else {
    next()
  }
})

export default router
